/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import commonLabels from "../../../common/labels/common_en.json";
import {
  getAllModulesList,
  getAllTypesList,
  getLookupOptionListPagination,
  manageLookupOptions,
  resetLookupOption,
  resetLookupOptionList,
} from "../actions/masterManagementAction";
import masterLabels from "../labels/master_en.json";
// import TablePagination from '../../common/components/TablePagination';
import { toastr } from "react-redux-toastr";
import ConfirmationDialog from "../../../common/components/ConfirmationDialog";
import TablePagination from "../../../common/components/TablePagination";
import LookupOptionForm from "./LookupOptionForm";
import Select from "react-select";

const LookupOptionList = () => {
  let rowPerPage = 10;
  const dispatch = useDispatch();
  let [addLookupOption, setAddLookupOption] = useState({
    Mode: false,
    moduleCode: false,
    typeCode: false,
  });
  let [searchMode, setSearchMode] = useState(false);
  let [textToSearch, setTextToSearch] = useState("");
  let [moduleCode, setModuleCode] = useState(false);
  let [typeCode, setTypeCode] = useState(false);
  let [parentType, setParentType] = useState(false);
  let [parentId, setParentId] = useState(null);
  let [listCurrentPage, setListCurrentPage] = useState(0);
  let [showModal, setShowModal] = useState(false);
  let [deleteLookupOption, setDeleteLookupOption] = useState(0);

  useEffect(() => {
    dispatch(getAllModulesList());
    dispatch(resetLookupOption());
    dispatch(resetLookupOptionList());
    setTextToSearch("");
    setTypeCode(false);
    setParentType(false);
    setParentId(null);
    // eslint-disable-next-line
  }, []);

  const inputRef = useRef();

  const onModuleChange = (e) => {
    dispatch(resetLookupOption());
    dispatch(resetLookupOptionList());

    setTextToSearch("");
    setTypeCode(false);

    let moduleSelectedCode = e.target.value;
    setModuleCode(moduleSelectedCode);
    dispatch(getAllTypesList(moduleSelectedCode));
  };

  const onTypeChange = (e) => {
    setTextToSearch("");
    let typeSelectedCode = e.target.value;
    setTypeCode(typeSelectedCode);

    moduleCode &&
      typeSelectedCode &&
      dispatch(
        getLookupOptionListPagination(
          0,
          rowPerPage,
          moduleCode,
          typeSelectedCode,
          textToSearch
        )
      );
  };

  const searchData = (textToSearch) => {
    setSearchMode(true);
    moduleCode && typeCode && dispatch(resetLookupOptionList());
    moduleCode &&
      typeCode &&
      dispatch(
        getLookupOptionListPagination(
          0,
          rowPerPage,
          moduleCode,
          typeCode,
          textToSearch
        )
      );
    (!moduleCode || !typeCode) &&
      toastr.error(commonLabels.SEARCH_VALIDATION_ERROR);
  };

  const {
    modulesList,
    typesList,
    lookupOptionsList,
    lookupOptionPageNoCounter,
  } = useSelector((state) => state.masterManagementReducer, shallowEqual);

  let tableCounter = lookupOptionPageNoCounter + 1;

  const manageLookupOption = (id) => {
    setShowModal(true);
    setDeleteLookupOption(id);
  };

  const deleteLookupOptionById = (id) => {
    setShowModal(false);
    let requestBody = { lookupOption: { id: id, isDeleted: true } };
    dispatch(
      manageLookupOptions(
        requestBody,
        rowPerPage,
        listCurrentPage,
        moduleCode,
        typeCode,
        textToSearch
      )
    );
  };

  const activeLookupOption = (id, isActive) => {
    let requestBody = { lookupOption: { id: id, isActive: !isActive } };
    dispatch(
      manageLookupOptions(
        requestBody,
        rowPerPage,
        listCurrentPage,
        moduleCode,
        typeCode,
        textToSearch
      )
    );
  };

  const moduleOptions =
    modulesList?.lookupOptionList
      ?.slice()
      .sort((a, b) => a.module.localeCompare(b.module))
      .map((el) => ({
        value: el.module,
        label: el.module,
      })) || [];

  const typeOptions =
    typesList?.lookupOptionList
      ?.filter((el) => el.type) // Ensure non-empty types
      .slice()
      .sort((a, b) => a.type.localeCompare(b.type))
      .map((el) => ({
        value: el.type,
        label: el.type,
      })) || [];

  return addLookupOption.Mode != false ? (
    <div>
      <LookupOptionForm
        addLookupOption={addLookupOption}
        setAddLookupOption={setAddLookupOption}
        setModuleCode={setModuleCode}
        setParentType={setParentType}
        setParentId={setParentId}
        parentType={parentType}
        parentId={parentId}
        moduleCode={moduleCode}
        typeCode={typeCode}
        setTypeCode={setTypeCode}
        setTextToSearch={setTextToSearch}
      />
    </div>
  ) : (
    <div
      className="border border-light"
      style={{ width: "100%", padding: "20px" }}
    >
      <div className="form-group">
        <div className="row">
          <div className="col-md-2">
            <label className="font-weight-bold">
              {masterLabels.lookupOptionList.Modules}
              <span className="redColor">*</span>
            </label>
            {/* <select
              className="form-select"
              name="moduleCode"
              onInput={onModuleChange}
              ref={inputRef}
              defaultValue={addLookupOption && addLookupOption.moduleCode}
            >
              <option key={0} value="">
                {commonLabels.COMBO_SELECT}
              </option>
              {modulesList &&
                modulesList.lookupOptionList &&
                modulesList.lookupOptionList.length > 0 &&
                modulesList.lookupOptionList
                  .slice()
                  .sort((a, b) => a.module.localeCompare(b.module))
                  .map((element, index) => (
                    <option key={index} value={element.module}>
                      {element.module}
                    </option>
                  ))}
            </select> */}

            <Select
              name="moduleCode"
              options={moduleOptions}
              onChange={(selectedOption) => {
                onModuleChange({
                  target: {
                    name: "moduleCode",
                    value: selectedOption?.value || "",
                  },
                });
              }}
              value={
                moduleOptions.find(
                  (option) =>
                    option.value === (addLookupOption?.moduleCode || moduleCode)
                ) || null
              }
              placeholder={commonLabels.COMBO_SELECT}
              isClearable
              ref={inputRef}
            />
          </div>
          <div className="col-md-3">
            <label className="font-weight-bold">
              {masterLabels.lookupOptionList.Types}
              <span className="redColor">*</span>
            </label>

            <Select
              name="typeCode"
              options={typeOptions}
              onChange={(selectedOption) => {
                onTypeChange({
                  target: {
                    name: "typeCode",
                    value: selectedOption?.value || "",
                  },
                });
              }}
              value={
                typeOptions.find((option) => option.value === typeCode) || null
              }
              placeholder={commonLabels.COMBO_SELECT}
              isClearable
              ref={inputRef}
            />
          </div>
          <div className="col-md-3 mt-3">
            <input
              type="text"
              className="form-control mt-2"
              name="textToSearch"
              value={textToSearch == false ? "" : textToSearch}
              placeholder={masterLabels.lookupOptionList.Text_To_Search_Label}
              onChange={(event) => {
                setTextToSearch(event.target.value);
                setSearchMode(false);
              }}
              maxLength="50"
            />
          </div>
          <div className="col-md-1  mt-3">
            <button
              className="form-control mt-2 btn-primary button_search"
              onClick={() => {
                searchData(textToSearch);
              }}
            >
              <i className="fa fa-search" type="button"></i>
            </button>
          </div>
          <div className="col-md-1"></div>
          <div className="col-md-2 text-right mt-4">
            <button
              className=" btn form-control btn-primary custom_button"
              onClick={() => {
                setAddLookupOption({ Mode: "Add" });
              }}
            >
              {masterLabels.lookupOptionList.Add_Lookup_Option_Btn}
            </button>
          </div>
        </div>
      </div>
      <br />
      <div className="form-group">
        {lookupOptionsList && lookupOptionsList.totalNoOfRecords > 0 ? (
          <div className="row">
            <div className="col-md-12">
              <table className="table table-bordered">
                <thead className="thead-light">
                  <tr>
                    {/* <th scope="col" className='w-10 text-center'>{masterLabels.lookupOptionList.No}</th> */}
                    <th scope="col" className="w-10 text-center">
                      {masterLabels.lookupOptionList.Id}
                    </th>
                    <th scope="col" className="w-40 text-left">
                      {masterLabels.lookupOptionList.Name}
                    </th>
                    <th scope="col" className="w-40 text-left">
                      {masterLabels.lookupOptionList.Abbr}
                    </th>
                    <th scope="col" className="w-10 text-center">
                      {masterLabels.lookupOptionList.Action}
                    </th>
                  </tr>
                </thead>
                <tbody className="small">
                  {lookupOptionsList.lookupOptionList &&
                    lookupOptionsList.lookupOptionList.map((element, index) => {
                      if (element) {
                        return (
                          <tr key={index}>
                            {/* <td className="w-10 word-break text-center">{tableCounter++}</td> */}
                            <td className="w-10 word-break text-center">
                              {element.id}
                            </td>
                            <td className="word-break text-left">
                              {element.label}
                            </td>
                            <td className="word-break text-left">
                              {element.abbr}
                            </td>
                            <td className="w-10 word-break text-center">
                              <i
                                role="button"
                                data-toggle="tooltip"
                                title={commonLabels.BUTTON_EDIT}
                                className="text-primary fa fa-edit"
                                onClick={() => {
                                  setAddLookupOption({
                                    Mode: "Edit",
                                    id: element.id,
                                    parentId: element.parentId,
                                    moduleCode: moduleCode,
                                    typeCode: typeCode,
                                  });
                                }}
                              ></i>
                              &nbsp;&nbsp;
                              <i
                                role="button"
                                data-toggle="tooltip"
                                title={
                                  element.isActive
                                    ? commonLabels.BUTTON_INACTIVE
                                    : commonLabels.BUTTON_ACTIVE
                                }
                                className={
                                  element.isActive === true
                                    ? "text-success fa fa-toggle-on"
                                    : "text-danger fa fa-toggle-off"
                                }
                                onClick={(e) => {
                                  activeLookupOption(
                                    element.id,
                                    element.isActive
                                  );
                                }}
                              ></i>
                              &nbsp;&nbsp;
                              <i
                                role="button"
                                data-toggle="tooltip"
                                title={commonLabels.BUTTON_DELETE}
                                className="text-danger fa fa-trash"
                                onClick={(e) => {
                                  manageLookupOption(element.id);
                                }}
                              ></i>
                            </td>
                          </tr>
                        );
                      }
                    })}
                </tbody>
              </table>
              {moduleCode && typeCode && (
                <TablePagination
                  paginationFor="lookup_option_list"
                  rowPerPage={rowPerPage}
                  setListCurrentPage={setListCurrentPage}
                  searchCode2={moduleCode}
                  searchCode3={typeCode}
                  textToSearch={textToSearch}
                  searchMode={searchMode}
                  totalCount={lookupOptionsList.totalNoOfRecords}
                />
              )}
            </div>
          </div>
        ) : (
          <div className="text-center">
            <font className="text-danger">
              {moduleCode && typeCode && commonLabels.NO_DATA_FOUND}
              {!moduleCode &&
                !typeCode &&
                masterLabels.lookupOptionList
                  .SELECT_MODULE_AND_TYPE_TO_FETCH_RESULT}
            </font>
          </div>
        )}
      </div>

      {
        <ConfirmationDialog
          showModal={showModal}
          Title={commonLabels.CONFIRMATION_MODAL_TITLE}
          Message={commonLabels.CONFIRMATION_MESSAGE}
          setShowModal={setShowModal}
          deleteRecord={deleteLookupOptionById}
          deletedId={deleteLookupOption}
          IsConfirmation={"true"}
        />
      }
    </div>
  );
};

export default LookupOptionList;
